<app-cargando *ngIf="cargando"></app-cargando>

<div class="encabezado">
  <p style="margin-bottom: 0px;">Metas</p>
</div>

<div class="row" style="padding: 5px;">
  
  <div class="col-lg-6 col-12">
    <label for="">MES</label>
    <select (change)="filtrar()" [(ngModel)]="FiltroMes" class="form-control">
      <option value="1">Enero</option>
      <option value="2">Febrero</option>
      <option value="3">Marzo</option>
      <option value="4">Abril</option>
      <option value="5">Mayo</option>
      <option value="6">Junio</option>
      <option value="7">Julio</option>
      <option value="8">Agosto</option>
      <option value="9">Septiembre</option>
      <option value="10">Octubre</option>
      <option value="11">Noviembre</option>
      <option value="12">Diciembre</option>
    </select>
  </div>

  <div class="col-lg-6 col-12">
    <label for="">AÑO</label>
    <select (change)="filtrar()" [(ngModel)]="FiltroAnio" class="form-control">
      <option value="2025">2025</option>
      <option value="2024">2024</option>
      <option value="2023">2023</option>
      <option value="2022">2022</option>
    </select>
  </div>

  <div class="col-12" style="padding: 10px;text-align: center;">
    <button (click)="limpiar()" type="button" class="btn btn-success">Limpiar <i class="fa-solid fa-arrows-rotate"></i></button>
  </div>
</div>

<div class="contenedor-tabla">
  <table class="table">
    <thead>
      <tr>
        <th scope="col">SlpCode</th>
        <th scope="col">Nombre</th>
        <th scope="col">Mes</th>
        <th scope="col">Año</th>
        <th scope="col">Valor</th>
        <th scope="col">
          <button (click)="crearMeta()" type="button" class="btn btn-success">
            CREAR
          </button>
        </th>
      </tr>
    </thead>
    <tbody>
      <tr *ngFor="let row of allmetasView;let i = index">
        <th>{{row.SlpCode}}</th>
        <td>{{row.NOMBRE}}</td>
        <td>
          <div *ngIf="row.MES == '1'">ENERO</div>
          <div *ngIf="row.MES == '2'">FEBRERO</div>
          <div *ngIf="row.MES == '3'">MARZO</div>
          <div *ngIf="row.MES == '4'">ABRIL</div>
          <div *ngIf="row.MES == '5'">MAYO</div>
          <div *ngIf="row.MES == '6'">JUNIO</div>
          <div *ngIf="row.MES == '7'">JULIO</div>
          <div *ngIf="row.MES == '8'">AGOSTO</div>
          <div *ngIf="row.MES == '9'">SEPTIEMBRE</div>
          <div *ngIf="row.MES == '10'">OCTUBRE</div>
          <div *ngIf="row.MES == '11'">NOVIEMBRE</div>
          <div *ngIf="row.MES == '12'">DICIEMBRE</div>

        </td>
        <td>{{row.ANIO}}</td>
        <td>{{row.VALOR | iNDCLP}}</td>

        <td>

          <button type="button" class="btn btn-warning" style="margin-right: 5px;" (click)="editarMeta(row)">
            <svg xmlns="http://www.w3.org/2000/svg" width="27" height="27" fill="#fff" class="bi bi-pencil-fill" viewBox="0 0 16 16">
              <path d="M12.854.146a.5.5 0 0 0-.707 0L10.5 1.793 14.207 5.5l1.647-1.646a.5.5 0 0 0 0-.708l-3-3zm.646 6.061L9.793 2.5 3.293 9H3.5a.5.5 0 0 1 .5.5v.5h.5a.5.5 0 0 1 .5.5v.5h.5a.5.5 0 0 1 .5.5v.5h.5a.5.5 0 0 1 .5.5v.207l6.5-6.5zm-7.468 7.468A.5.5 0 0 1 6 13.5V13h-.5a.5.5 0 0 1-.5-.5V12h-.5a.5.5 0 0 1-.5-.5V11h-.5a.5.5 0 0 1-.5-.5V10h-.5a.499.499 0 0 1-.175-.032l-.179.178a.5.5 0 0 0-.11.168l-2 5a.5.5 0 0 0 .65.65l5-2a.5.5 0 0 0 .168-.11l.178-.178z"/>
            </svg>
          </button>

          <button type="button" class="btn btn-danger" style="margin-right: 5px;" (click)="eliminarMeta(row)">

            <svg xmlns="http://www.w3.org/2000/svg" width="27" height="27" fill="#fff" class="bi bi-x-lg" viewBox="0 0 16 16">
              <path d="M2.146 2.854a.5.5 0 1 1 .708-.708L8 7.293l5.146-5.147a.5.5 0 0 1 .708.708L8.707 8l5.147 5.146a.5.5 0 0 1-.708.708L8 8.707l-5.146 5.147a.5.5 0 0 1-.708-.708L7.293 8 2.146 2.854Z"/>
            </svg>

          </button>

          <button (click)="copiar(row)" type="button" class="btn btn-primary">
            <i style="font-size: 26px;" class="fa-solid fa-copy"></i>
          </button>





        </td>
      </tr>

    </tbody>
  </table>
</div>
